"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var OrgQuestLimit = function OrgQuestLimit(props) {
  var _useState = (0, _react.useState)(props.operation === 'edit'),
    _useState2 = _slicedToArray(_useState, 2),
    edit = _useState2[0],
    setEdit = _useState2[1];
  var type = props.displaySettings.fieldProps.type;
  var label = {
    respondent: 'Respondent',
    sms: 'SMS'
  };
  (0, _react.useEffect)(function () {
    if (!props.level) {
      return;
    }
    var levels = {
      respondent: {
        Basic: '5000',
        Premium: '20000',
        Unlimited: ''
      },
      sms: {
        Basic: '0',
        Premium: '1200',
        Unlimited: ''
      }
    };
    props.field.onChange(edit ? props.field.initialValue : levels[type][props.level]);
    setEdit(false);
  }, [props.level]);
  return /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: props.field,
    label: "".concat(label[type], " Limit")
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: "form-control"
  }, (0, _cccisdReduxFormHelpers.domOnlyProps)(props.field), {
    placeholder: "Unlimited"
  })));
};
var mapStateToProps = function mapStateToProps(state) {
  var _state$form, _state$form$DynamicFo, _state$form$DynamicFo2;
  return {
    level: (_state$form = state.form) === null || _state$form === void 0 ? void 0 : (_state$form$DynamicFo = _state$form.DynamicForm) === null || _state$form$DynamicFo === void 0 ? void 0 : (_state$form$DynamicFo2 = _state$form$DynamicFo.level) === null || _state$form$DynamicFo2 === void 0 ? void 0 : _state$form$DynamicFo2.value
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {})(OrgQuestLimit);